import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { ROLE_CODE } from '../../common/const';

const ExternalDataHistoryActionRoute = (props) => {
  const { userInfo } = props;
  if (userInfo !== null && userInfo.role_list.indexOf(ROLE_CODE.EXTERNALDATA) >= 0) {
    return <Route {...props} />;
  }
  return <Redirect to="/error" />;
};

export default connect(
  (state) => ({
    userInfo: state.common.userInfo,
  }),
)(ExternalDataHistoryActionRoute);
